module.exports = __webpack_public_path__ + "static/media/slim-cereja.5f356663.webp";